/**
 * Poker admin allowlist — Puter / Grudge ID identities that may use /admin.
 * SSOT for client gate UI + worker `adminIdentityFromRequest`.
 *
 * Align with: GrudgeBuilder/shared/fleet/adminAllowlist.ts
 * Gate entry: https://id.grudge-studio.com/admin (not player /login)
 *
 * Primary: Puter **molochdadev** · **grudachain** via Grudge ID admin gate
 * Emails: same humans (fleet master/admin)
 * Wallet: treasury auto-admin for house ops (secondary)
 */

export const ADMIN_TREASURY_WALLET =
  "98jzgFFkPhrw9sfr5YyttTpCBiJyid6tzxxJjXrj7xXK";

/** Normalized lowercase emails */
export const ADMIN_EMAILS = [
  "grudgedev@gmail.com",
  "jonbemmons@gmail.com",
] as const;

/**
 * Puter usernames + Grudge handles (case-insensitive).
 * molochdadev / MolochDaDev · grudachain / GRUDACHAIN
 */
export const ADMIN_HANDLES = [
  "molochdadev",
  "molochdagod",
  "grudachain",
  "grudgechain",
  "grudadev",
] as const;

export function normalizeAdminToken(s: string | null | undefined): string {
  return String(s || "")
    .trim()
    .toLowerCase()
    .replace(/^@+/, "");
}

export function isAdminEmail(email: string | null | undefined): boolean {
  const e = normalizeAdminToken(email);
  if (!e) return false;
  return (ADMIN_EMAILS as readonly string[]).includes(e);
}

export function isAdminHandle(handle: string | null | undefined): boolean {
  const h = normalizeAdminToken(handle);
  if (!h) return false;
  if ((ADMIN_HANDLES as readonly string[]).includes(h)) return true;
  // Puter paths sometimes appear as molochdadev/Sites/...
  return (ADMIN_HANDLES as readonly string[]).some(
    (a) => h === a || h.startsWith(`${a}/`) || h.endsWith(`/${a}`),
  );
}

export function isAdminTreasuryWallet(
  wallet: string | null | undefined,
): boolean {
  if (!wallet) return false;
  return wallet.trim() === ADMIN_TREASURY_WALLET;
}

export function adminAllowlistPublic() {
  return {
    handles: [...ADMIN_HANDLES],
    emails: [...ADMIN_EMAILS],
    treasuryWallet: ADMIN_TREASURY_WALLET,
    puterRequired:
      "Sign in as Puter molochdadev or grudachain (or matching Grudge ID email/handle), or connect treasury wallet.",
  };
}
